// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IFormPurchaseOrder } from '~/utils/interface/purchaseOrder';
import { EMPTY_STRING } from '~/utils/constants/common';

export const schema = (t: TFunction): yup.ObjectSchema<IFormPurchaseOrder> => {
  return yup.object().shape({
    vendorId: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    orderId: yup.string().optional().trim(),
    quoteId: yup.string().optional().trim(),
    approvedBy: yup.string().optional().trim(),
    type: yup.string().optional().trim(),
    text: yup.string().optional().trim(),
    poNumber: yup.string().optional().trim(),
    neededByDate: yup.string().optional().trim(),
    deliveryDate: yup.string().optional().trim(),
    pickupDate: yup.string().optional().trim(),
    method: yup.string().optional().trim(),
    pickupType: yup.string().optional().trim(),
    deliveryTo: yup.string().optional().trim(),
    shippingPrice: yup.string().optional().trim(),
    note: yup.string().optional().trim(),
    approveImmediately: yup.boolean().optional(),
    purchaseOrderItems: yup.array().optional(),
    deleteItemIds: yup.array().optional(),
  });
};

export const defaultValuesPurchaseOrderForm: IFormPurchaseOrder = {
  vendorId: EMPTY_STRING,
  orderId: EMPTY_STRING,
  quoteId: EMPTY_STRING,
  approvedBy: EMPTY_STRING,
  approveImmediately: false,
  type: EMPTY_STRING,
  poNumber: EMPTY_STRING,
  neededByDate: EMPTY_STRING,
  deliveryDate: EMPTY_STRING,
  pickupDate: EMPTY_STRING,
  method: EMPTY_STRING,
  pickupType: EMPTY_STRING,
  deliveryTo: EMPTY_STRING,
  shippingPrice: EMPTY_STRING,
  note: EMPTY_STRING,
  purchaseOrderItems: [],
  deleteItemIds: [],
};
